import React from 'react';
import styled from 'styled-components';
import { PlusCircle } from '@finect/tabular-icons/plusCircle';
import { Small } from '@finect/tabular-core/Small';
export var Block = styled.div.withConfig({
  displayName: "CellPlusAction__Block",
  componentId: "sc-1geb6q-0"
})(["display:flex;align-items:center;justify-content:center;height:100%;padding:10px 20px;cursor:pointer;background-color:", ";text-align:center;&:hover{color:", ";}svg{margin-right:4px;}"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.cardsBackgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.colors.primary);
});
export var CellPlusAction = function CellPlusAction(_ref3) {
  var _ref3$placeholder = _ref3.placeholder,
    placeholder = _ref3$placeholder === void 0 ? 'Añadir' : _ref3$placeholder,
    onClick = _ref3.onClick;
  return React.createElement(Block, {
    onClick: onClick
  }, React.createElement(PlusCircle, null), React.createElement("div", null, React.createElement(Small, null, placeholder)));
};